import React, { useState } from "react";
import { Box, Grid2, styled, Tab, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Tabs, Typography, useTheme } from "@mui/material";
import { useGetVarianceDriversQuery } from "store/slices/apis/scheduleDashboarSlice";
import { useParams } from "react-router-dom";
import dayjs from "dayjs";
import PaginationComponent from "components/ui-components/PaginationComponent";

const StyledTab = styled(Tab)(({ theme }) => ({
    textTransform: "none", // Prevent uppercase
    fontWeight: "400",
    fontSize: "14px",
    color: "#37352F",
    padding: '0px',
    minHeight: '0px',
    minWidth: '0px',
    margin: '20px 20px 5px 5px',
    "&.Mui-selected": {
        color: `${theme?.customSettings?.themeColor}`,
    }
}));

const StyledTableHead = styled(TableCell)(({ theme }) => ({
    fontWeight: "500", fontSize: '14px', color: '#505258', padding: '10px 14px 10px 14px',
    backgroundColor: '#F8F8F8', border: '1px solid #D8D8D8', letterSpacing: '-0.2px', lineHeight: '20px', textAlign: "center",
}));

const StyledTableBody = styled(TableCell)(({ theme }) => ({
    fontWeight: "400", fontSize: '14px', color: '#5052588A', padding: '10px 14px 10px 14px',
    backgroundColor: '#FFFFFF', border: '1px solid #D8D8D8', letterSpacing: '-0.2px', lineHeight: '20px', textAlign: "center",
}));

function CustomTabPanel(props) {
    const { children, value, index, ...other } = props;

    return (
        <div
            role="tabpanel"
            hidden={value !== index}
            id={`simple-tabpanel-${index}`}
            aria-labelledby={`simple-tab-${index}`}
            {...other}
        >
            {value === index && <Box sx={{ p: 3 }}>{children}</Box>}
        </div>
    );
}

const types = ['All', 'Engineering', 'Procurement', 'Construction'];

const CriticalActivities = () => {

    const [selectedTab, setSelectedTab] = useState(0);

    const theme = useTheme();

    const { projectId } = useParams();
    const [selectedDate, setSelectedDate] = useState("2025-05-01");

    const { data, isLoading, error } = useGetVarianceDriversQuery({
        projectId,
        period: selectedDate,
    });

    const activities = data?.map((activity, index) => ({
        type: activity.subCateogary1 === 'E' ? 'Engineering' : activity.subCateogary1 === 'P' ? 'Procurement' : 'Construction',
        name: activity.activity,
        baseline: activity.baselineDate ? dayjs(activity.baselineDate).format('DD MMM, YYYY') : "-",
        forecast: activity.forecastCompletionDate ? dayjs(activity.forecastCompletionDate).format('DD MMM, YYYY') : "-",
        variance: activity.varianceInDays,
    })) || [];

    const filteredActivities =
        types[selectedTab] === 'All'
            ? activities
            : activities.filter((a) => a.type === types[selectedTab]);

    const [currentPage, setCurrentPage] = useState(1);
    const rowsPerPage = 5;
    const totalPages = Math.ceil((filteredActivities?.results?.length || filteredActivities?.length || 0) / rowsPerPage);

    const startIndex = (currentPage - 1) * rowsPerPage;
    const endIndex = startIndex + rowsPerPage;
    const currentRows = (filteredActivities?.results || filteredActivities || []).slice(startIndex, endIndex);

    return (
        <Box sx={{ padding: 2, border: '1px solid #2525252E', borderRadius: '7px', background: "#FFFFFF", height: "470px", overflowY: 'auto' }}>
            <Grid2 container>
                <Grid2 size={{ xs: 12, md: 12 }}>
                    <Typography variant="h6" sx={{ fontWeight: "500", fontSize: '18px', color: `#182A4E`, lineHeight: '100%', letterSpacing: '-0.4px' }}>
                        Critical Activities by EPC
                    </Typography>
                    <Grid2 container spacing={1}>
                        <Grid2 size={12}>
                            <Box sx={{ borderBottom: 0, borderColor: 'divider' }}>
                                <Tabs value={selectedTab}
                                    onChange={(_, newValue) => { setSelectedTab(newValue); setCurrentPage(1); }}
                                    sx={{
                                        minHeight: "0px",
                                        "& .MuiTabs-indicator": { backgroundColor: `${theme?.customSettings?.themeColor}` },
                                    }}>
                                    {types.map((type, index) => (
                                        <StyledTab key={index} label={type} />
                                    ))}
                                </Tabs>

                                <TableContainer sx={{ mt: 2 }}>
                                    <Table>
                                        <TableHead>
                                            <TableRow>
                                                <StyledTableHead>
                                                    Sl No
                                                </StyledTableHead>
                                                <StyledTableHead>
                                                    Activity
                                                </StyledTableHead>
                                                <StyledTableHead>
                                                    Baseline
                                                </StyledTableHead>
                                                <StyledTableHead>
                                                    Forecast
                                                </StyledTableHead>
                                                <StyledTableHead>
                                                    Variance
                                                </StyledTableHead>
                                            </TableRow>
                                        </TableHead>
                                        <TableBody>
                                            {currentRows.length > 0 ? (
                                                currentRows.map((row, index) => {
                                                    const serialNo = (currentPage - 1) * rowsPerPage + index + 1;
                                                    return (
                                                        <TableRow key={index}>
                                                            <StyledTableBody>{serialNo}</StyledTableBody>
                                                            <StyledTableBody>{row.name || "-"}</StyledTableBody>
                                                            <StyledTableBody>{row.baseline}</StyledTableBody>
                                                            <StyledTableBody>{row.forecast}</StyledTableBody>
                                                            <StyledTableBody>{row.variance ?? "-"}</StyledTableBody>
                                                        </TableRow>
                                                    );
                                                })
                                            ) : (
                                                <TableRow>
                                                    <StyledTableBody colSpan={8} align="center">
                                                        No data available
                                                    </StyledTableBody>
                                                </TableRow>
                                            )}
                                        </TableBody>
                                    </Table>
                                </TableContainer>
                            </Box>
                        </Grid2>
                    </Grid2>
                </Grid2>
            </Grid2>

            <Box sx={{ display: "flex", justifyContent: "flex-end", backgroundColor: "#fff", p: 1 }}>
                {!isLoading && (
                    <PaginationComponent
                        pageNumber={currentPage}
                        totalPages={totalPages || 1}
                        onPageChange={setCurrentPage}
                    />
                )}
            </Box>

        </Box >
    );
};

export default CriticalActivities;
